module.exports = __webpack_public_path__ + "img/barbados.aa77f8c2.jpg";